import SelectFilterDropdown, {
  SelectFilterOption,
} from "@/components/common/dropdown/SelectFilterDropdown";
import { IconMovie, IconPhoto, IconPhotoVideo } from "@tabler/icons-react";

export type MediaType = "image" | "video" | null;

type Props = {
  selectedType: MediaType;
  onChange: (type: MediaType) => void;
  className?: string;
  disabled?: boolean;
};

const options: SelectFilterOption<MediaType>[] = [
  {
    key: "all",
    label: "All",
    value: null,
    icon: (props) => (
      <IconPhotoVideo
        size={17}
        color="#5344FF"
        className={`shrink-0 ${props?.className ?? ""} h-[18px] w-[18px]`}
      />
    ),
  },
  {
    key: "image",
    label: "Images",
    value: "image",
    icon: (props) => (
      <IconPhoto
        size={16}
        color="#FF4699"
        className={`shrink-0 ${props?.className ?? ""}`}
      />
    ),
  },
  {
    key: "video",
    label: "Videos",
    value: "video",
    icon: (props) => (
      <IconMovie
        size={16}
        color="#018C62"
        className={`shrink-0 ${props?.className ?? "h-[17px] w-[17px]"}`}
      />
    ),
  },
];

const MediaTypeDropdown = ({ selectedType, onChange, disabled, className }: Props) => {
  return (
    <SelectFilterDropdown
      options={options}
      selected={selectedType}
      onChange={onChange}
      className={className}
      disabled={disabled}
      label="Media Type"
      placeholder="All"
    />
  );
};

export default MediaTypeDropdown;
